import { Component, OnInit } from "@angular/core";
import {
  NextPageService,
  NavigationLocation,
  PageLayout,
  SearchType,
  SliderType,
} from "@cvx/nextpage";
import { LoggedUserService } from "./services/common/logged-user.service";
import { RoutesService } from "./services/routes.service";
import { CalAngularService } from "@cvx/cal-angular";
import { forkJoin } from "rxjs";
import { ActivatedRoute } from "@angular/router";
 
@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    styleUrls: ["app.component.css"],
    standalone: false
})
export class AppComponent implements OnInit {
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  SearchType = SearchType;
  SliderType = SliderType;
  loggedUsername: string = "";
  filteredRoutesLoaded: boolean = false;
  dataLoading: boolean = true;
  isPopup = false;
 
  constructor(
    private NP: NextPageService,
    private loggedUserService: LoggedUserService,
    private authService: CalAngularService,
    private routesService: RoutesService,
    private route: ActivatedRoute
  ) {
    this.NP.options.sitename = "Service Bulletin Management";
    this.setLoggedUserInfo();
    this.route.queryParams.subscribe(params => {
      this.isPopup = params['popup'] === 'true';
    });
  }
 
  ngOnInit() {
    this.dataLoading = true;
    this.routesService.filteredRoutesLoaded.subscribe((loaded) => {
      if (loaded) {
        this.filteredRoutesLoaded = loaded;
        this.dataLoading = false;
      }
    });
  }
 
  setLoggedUserInfo() {
    if (this.authService.isUserSignedIn()) {
      let accountInfo = this.authService.getAccount();
      this.loggedUsername = accountInfo.username;
 
      forkJoin({
        userData: this.loggedUserService.getLoggedUserData(),
      }).subscribe((results) => {
        if (results.userData !== null) {
          this.loggedUserService.setLoggedUserData(results.userData);
        }
      });
    } else {
      this.authService.userInitiatedSignIn();
    }
  }
}